import RecordType from '../../../Models/Locations/recordType';
import { AssociationDetailsViewModel } from '../../../Models/Association/association-details-viewmodels';
import { useAssociations } from '../../../hooks/associations/useAssociations';
import AssociationsControls from '../AssociationsControls';

export default function Associations({
  supportedRecordTypes,
  providers,
  form,
  setAssociationData,
  associationData,
  parentEntityId,
}: Readonly<{
  supportedRecordTypes: RecordType[];
  providers: any[];
  form: any;
  setAssociationData: any;
  associationData: AssociationDetailsViewModel;
  parentEntityId: number | undefined;
}>) {
  const { open, handleClickOpen, handleCloseDialog, removeAssociation } =
    useAssociations(form, setAssociationData);

  const handleCustodianSelect = (custodian: any) => {
    const newAssociation = {
      childEntityId: custodian.id,
      childEntityName: custodian.name,
      relationshipType: null,
      preferenceNotes: null,
      isBidirectional: false,
      parentRoleType: null,
      childRoleType: null,
      disabled: false,
      associationRecordTypes: [
        {
          dateFrom: null,
          dateTo: null,
          custodianProviderId: null,
          recordTypeId: null,
        },
      ],
    };
    const currentAssociations = form.values.entityAssociations ?? [];
    const updatedAssociations = [...currentAssociations, newAssociation];
    form.setFieldValue('entityAssociations', updatedAssociations);
    setAssociationData((prev: any) => ({
      ...prev,
      parentEntityId: parentEntityId,
      parentEntityName: associationData.parentEntityName,
      entityAssociations: updatedAssociations,
    }));
    handleCloseDialog();
  };

  return (
    <AssociationsControls
      associationData={associationData}
      setAssociationData={setAssociationData}
      removeAssociation={removeAssociation}
      supportedRecordTypes={supportedRecordTypes}
      providers={providers}
      form={form}
      open={open}
      handleCloseDialog={handleCloseDialog}
      handleCustodianSelect={handleCustodianSelect}
      handleClickOpen={handleClickOpen}
      showAddButton={!associationData?.disabled}
      entityLabel="Custodian"
      formKeyName="entityAssociations"
    />
  );
}
